// import when from "when"
// import Sound from "./sounds"
import {Howl, Howler} from 'howler';
import {TweenMax} from 'gsap'

import Ambiant from "@/assets/sounds/A_music_loop.mp3"
import tuto from "@/assets/sounds/A_amb_tutorial_loop.mp3"
import level1 from "@/assets/sounds/A_level1_loop.mp3"
import level2 from "@/assets/sounds/A_level2_loop.mp3"
import level3 from "@/assets/sounds/A_level3_loop.mp3"

import Leaves from "@/assets/sounds/B_leaves_transition.mp3"
import Plane from "@/assets/sounds/B_plane.mp3"

import HandAppear from "@/assets/sounds/C_hand_apparition.mp3"
import GameStart from "@/assets/sounds/C_game_start.mp3"
import Reveal from "@/assets/sounds/C_sign_reveal.mp3"
import Win from "@/assets/sounds/C_game_win.mp3"
import Loose from "@/assets/sounds/C_game_lose.mp3"
import RoundWin from "@/assets/sounds/C_round_win.mp3"
import RoundLoose from "@/assets/sounds/C_round_lose.mp3"

import Count from "@/assets/sounds/C_count.mp3"
import LevelUp from "@/assets/sounds/C_level_up.mp3"

import CTA from "@/assets/sounds/D_CTA.mp3"
import Spinner from "@/assets/sounds/D_hourglass.mp3"
import Hover from "@/assets/sounds/D_hover.mp3"
import SoundSwitch from "@/assets/sounds/D_sound_switch.mp3"

import { getCookie, setCookie, eraseCookie } from '@/js/utils/helpers'

class AudioManager {
    constructor(){
        this.init()
    }

    init(){
        this.soundLoader()
        this.handleCookie()
    }
    soundLoader () {
        this.ambiant = new Howl({
            src: [Ambiant],
            sprite : {
              begin: [],
              loop: []
            }
        });

        this.levels = [
          new Howl({
            src: [tuto],
          }),
          new Howl({
            src: [level1],
          }),
          new Howl({
            src: [level2],
          }),
          new Howl({
            src: [level3],
          }),
        ]
        this.ambiant.on('load', () => {
          this.ambiant._sprite.begin = [0, this.ambiant._duration*1000 - 4000, false]
          this.ambiant._sprite.loop = [4000,  this.ambiant._duration*1000 - 2*4000, true]
        })

        this.levels.map(el => {
          el.on('load', () => {
            el._sprite.begin = [0, 31000, false]
            el._sprite.loop = [1000,  30000, true]
          })
        })
        this.levels[0]._sprite.begin =  [0, 31000, false]
        this.levels[0]._sprite.loop = [1000,  30000, true]

        this.leaves = new Howl({
          src: [Leaves]
        });
        this.plane = new Howl({
          src: [Plane]
        });
        this.handAppear = new Howl({
          src: [HandAppear]
        });
        this.gameStart = new Howl({
          src: [GameStart]
        });
        this.reveal = new Howl({
          src: [Reveal]
        });
        this.win = new Howl({
          src: [Win]
        });
        this.loose = new Howl({
          src: [Loose]
        });
        this.roundWin = new Howl({
          src: [RoundWin]
        });
        this.roundLoose = new Howl({
          src: [RoundLoose]
        });
        this.count = new Howl({
          src: [Count]
        });
        this.levelUp = new Howl({
          src: [LevelUp]
        });
        this.cta = new Howl({
          src: [CTA]
        });
        this.spinner = new Howl({
          src: [Spinner]
        });
        this.hover = new Howl({
          src: [Hover]
        });
        this.soundSwitch = new Howl({
          src: [SoundSwitch]
        });
    }
    handleCookie () {
      if (getCookie('muted') === '1') {
        Howler.mute(true)
      }
    }
    startAmbiant () {
        this.ambiantBegin = this.ambiant.play('begin')
        
         this.ambiant.on('end',  () => {
          this.ambiant.stop('begin')
          this.ambiant.play('loop')
        }, this.ambiantBegin)
        // this.ambiant.onend(this.ambiantBegin, () => {
        //   console.log('end')
        //   this.ambiant.stop('begin')
        //   this.ambiant.play('loop')
        // })
        this.ambiant.volumeVal = 1
    }
    setRound(id) {
      if(this.isMuted) return
      
      if(this.levels[id - 1]){
        // this.volume = 1/(1 + (Math.abs((id-1) - 3))/3)
        this.volume = 1
        TweenMax.to(this, 4, {volume: 0, onUpdate: () => {this.levels[id - 1].volume(this.volume)}, onComplete: () => {this.levels[id - 1].stop()}})
        // this.levels[id - 1].volume(0)
        // this.levels[id - 1].on('fade', () => {this.levels[id - 1].stop()})
      }
      
      TweenMax.to(this.ambiant, 4, {volumeVal:  1/(1 + ((id))/2), onUpdate: () => {this.ambiant.volume(this.ambiant.volumeVal)}})
      
      // console.log(id, 'ambiant : ' + 1/(1 + ((id))/3), 'nappe : ' + 1/(1 + (Math.abs((id-3)))/3))
      // this.levels[id].volume(1/(1 + (Math.abs((id-3)))/3))
      this.levels[id].volume(1)
      this.levels[id].beginLoop = this.levels[id].play('begin')
      this.levels[id].on('end',  () => {
        this.levels[id].stop('begin')
        this.levels[id].play('loop')
      }, this.levels[id].beginLoop)
    }

    endRounds() {
      if(this.isMuted) return
      this.levels[2].fade(1, 0, 2000)
      this.levels[2].on('fade', () => {this.levels[2].stop()})
      TweenMax.to(this.ambiant, 4, {volumeVal: 1, onUpdate: () => {this.ambiant.volume(this.ambiant.volumeVal)}})
    }

    play(sound) {
        this[sound].play()
    }
    stop(sound) {
      this[sound].stop()
    }
    toggle (status) {
      if (status) {
        eraseCookie('muted')
      } else {
        setCookie('muted', '1', 30)
      }
        Howler.mute(!status)
        this.isMuted = status
        // status ? Howler.volume(1) : Howler.volume(0)
    }



}

export default AudioManager
